import { ENVIRONMENTS, ENV_PRODUCTION, type Environment } from '@/constants/environments'

const env = import.meta.env.VITE_ENV
const environment: Environment = env && env in ENVIRONMENTS ? (env as Environment) : ENV_PRODUCTION
const environmentConfig = ENVIRONMENTS[environment]

export const formatTitleWithEnvironment = (title: string): string => {
  const prefix = environmentConfig.titlePrefix ?? ''
  if (!prefix) return title
  return title.startsWith(prefix) ? title : `${prefix}${title}`
}

export const applyEnvironmentFavicon = () => {
  const favicon = environmentConfig.favicon
  if (!favicon) return

  const head = document.head
  if (!head) return

  const linkSelector = 'link[rel~="icon"]'
  let link = head.querySelector<HTMLLinkElement>(linkSelector)
  if (!link) {
    link = document.createElement('link')
    link.rel = 'icon'
    head.appendChild(link)
  }

  const resolvedFaviconUrl = new URL(favicon, window.location.origin).href
  if (link.href === resolvedFaviconUrl) return

  link.href = resolvedFaviconUrl
}
